const PADDLE_JS_SRC = "https://cdn.paddle.com/paddle/v2/paddle.js";

let paddleScriptPromise = null;
let initializedToken = "";

function loadPaddleScript() {
  if (window.Paddle) return Promise.resolve(window.Paddle);
  if (paddleScriptPromise) return paddleScriptPromise;
  paddleScriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${PADDLE_JS_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(window.Paddle));
      existing.addEventListener("error", () => reject(new Error("Could not load Paddle.js")));
      return;
    }
    const script = document.createElement("script");
    script.src = PADDLE_JS_SRC;
    script.async = true;
    script.onload = () => resolve(window.Paddle);
    script.onerror = () => reject(new Error("Could not load Paddle.js"));
    document.head.appendChild(script);
  });
  return paddleScriptPromise;
}

export async function openPaddleCheckout(config, handlers = {}) {
  const Paddle = await loadPaddleScript();
  if (!Paddle || !config || !config.client_token || !config.price_id) {
    throw new Error("Paddle checkout is not configured");
  }
  const eventCallback = typeof handlers.onEvent === "function" ? handlers.onEvent : undefined;
  if (initializedToken !== config.client_token) {
    if (typeof Paddle.Environment?.set === "function") {
      Paddle.Environment.set(config.environment === "sandbox" ? "sandbox" : "production");
    }
    const init = { token: config.client_token };
    if (eventCallback) init.eventCallback = eventCallback;
    Paddle.Initialize(init);
    initializedToken = config.client_token;
  } else if (eventCallback && typeof Paddle.Update === "function") {
    Paddle.Update({ eventCallback });
  }
  const checkout = {
    items: [{ priceId: config.price_id, quantity: 1 }],
    customData: config.custom_data || {},
    settings: { displayMode: "overlay" },
  };
  if (config.customer_email) {
    checkout.customer = { email: config.customer_email };
  }
  Paddle.Checkout.open(checkout);
}
